import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CmsCouponsListImpl from './cms-coupons-list.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that renders CMS sport, price boost and pre-built bet builder coupon sections.
 *
 * @class CmsCouponsList
 * @memberof Mojito.Modules
 */

/**
 * CmsCouponsList prop types.
 *
 * @memberof Mojito.Modules.CmsCouponsList
 */

/**
 * @property {string} couponsListId - CMS coupons list id.
 *
 * @memberof Mojito.Modules.CmsCouponsList.CmsCouponsList
 */
const propTypes = {
    couponsListId: PropTypes.string.isRequired,
};

export default UIView('CmsCouponsList', CmsCouponsListImpl, propTypes);
